/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_3_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worksheet data import using saved formula results. Live formulas, formatting and objects are not preserved as a full workbook conversion.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按已保存的公式结果导入工作表数据，不能完整保留可计算公式、格式及对象。`)
};

/**
* | output |
* | --- |
* | "Worksheet data import using saved formula results. Live formulas, formatting and objects are not preserved as a full workbook conversion." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_3_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_3_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_3_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_3_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_3_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_3_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_3_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.3.table.rows.3.1" }